import { render, staticRenderFns } from "./DetailExperimentTable.vue?vue&type=template&id=9304b9ac"
import script from "./DetailExperimentTable.vue?vue&type=script&lang=js"
export * from "./DetailExperimentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports